import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import TextFilter from './TextFilter';
import { Dropdown } from 'primereact/dropdown';
import PropertyFilter from './PropertyFilter';
import React, { useState } from "react";

const CategoryFilterMenu = props => {
  const {selectedProperty, setSelectedProperty, propOptions, setTextFilter, metadata, shownGenes, setShownGenes, attributeTypes, visibilityToggle} = props;
  const [showMenu, setShowMenu] = useState(true);
  const items1 = [
    {
        label:<><div>Color By</div></> ,
        items: [
            {
                template: (items) => {
                  return (
                    <div className="flex align-items-center">
                        {/* <label htmlFor="dropdownCategory" className="ml-2">Select Category</label> */}
                        <Dropdown inputId="dropdownCategory" value={selectedProperty} onChange={(e) => setSelectedProperty(e.target.value)} options={propOptions}
                          className="w-full md:w-9rem" style={{"marginRight": "1rem", "marginLeft": "1rem"}}/>
                    </div>
                  )
                }
            }
        ]
    },
    {
        label: 'Filter by Strain Name',
        items: [
            {
              template: (items) => {
                return (
                  <TextFilter setTextFilter={setTextFilter}/>
                )
              }
            },
        ]
    },
    {
      label: 'Filter by Attribute',
      items: [
        {
          template: () => {
            return Object.keys(metadata).length ? (
              <PropertyFilter metadata={metadata} shownGenes={shownGenes} setShownGenes={setShownGenes} attributeTypes={attributeTypes}/>
            ) : <></>
          }
        }
      ]
    }
  ];
  
  return (
    <div className="flex justify-content-left" style={{'width': '350px'}} >
    {showMenu || !visibilityToggle ? <Menu className="w-full md:w-20rem"  model={items1}/> : null}
    {showMenu || !visibilityToggle ? null : <Button label="Show Display Options" icon="pi pi-bars" onClick={(event) => setShowMenu(!showMenu)}/>}
    {showMenu && visibilityToggle ? <Button label="" icon="pi pi-bars" text severity="warning" size="large" onClick={(event) => setShowMenu(!showMenu)}/> : null}
    </div>
  )
}

export default CategoryFilterMenu;
